import generalUpload from "../_section/upload.class";

export class userProofOfAddressUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        }, {
            name: 'address',
            label: 'Address',
            type: 'text'
        }
    ]
}
export class adminProofOfAddressUpload extends userProofOfAddressUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.stampRequired = true; // must happen before values calced, as upload-steps depend on it
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(3,'month'),
            })
        }
    }
}
